import styles from './Header.module.css'
import logo from '../Img/Logo/logo.png'
import React, {useEffect, useRef} from "react";
import useApiQuery, {ApiQueryResponse} from "../ApiQuery/UseApiQuery";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {
    ReduxStateInt, sendActionMessage,
    setAuthLogin,
    setAuthToken,
    setBaseRegion,
    setLoginState,
    setSlider, setTfFilter, setXFilterValue
} from "../Reducer/GlobalReducer";
import iconLK from "../Img/icon_lk.png";
import iconGeo from "../Img/icon_geo.png";
function Header()
{
    const navigate = useNavigate();
    const data = useRef({name:"Hello", id:[]})
    const tfFilter = useSelector((state:ReduxStateInt)  => {return state.tarifFilter} )
    const xfFilter = useSelector((state:ReduxStateInt)  => {return state.xFilter} )

    const mockData = useRef(null)
    const [ldrLogout,rsLogout,exLogout] = useApiQuery("/auth/logout","get",mockData,cbLogout);
    const isRegionChanged = useSelector((state:ReduxStateInt)  => {return state.baseRegion.isChanged})
    const baseRegion = useSelector((state:ReduxStateInt)  => {return state.baseRegion});


    const isLogin =  useSelector((state:ReduxStateInt)  => {return state.isLogin})
    const authUser =  useSelector((state:ReduxStateInt)  => {return state.authLogin})

    const onRec = (dt: any)=>{
        console.log("executed", dt)

    }
    const dispatch = useDispatch()



    useEffect(()=>{
        //run().then((e:any)=>{console.log(e)})
    },[])

    function cbLogout(payload:ApiQueryResponse){
        if(payload.success || true)
        {
            dispatch(setAuthToken(""))
            dispatch(setAuthLogin(null))
            dispatch(setLoginState(false))
            navigate('/')
        }
    }


    const moveHome = () =>{

        dispatch(sendActionMessage("hello"))
        dispatch(setSlider({sliderMode:0}));
        dispatch(setTfFilter({...tfFilter,active: false}))
        dispatch(setXFilterValue({...xfFilter,active: false,val:""}))
        navigate('/')

    }
    const lkMake=() =>{
        if(isLogin)exLogout().then()
        else navigate('/auth')
    }

    const buildLK = () =>{
        return(
            <div className={styles.lkContMain}>
                <div className={[styles.baseOption, styles.lk,styles.plBox].join(' ')} onClick={()=>navigate('/auth')}>
                    <div>
                        <span>Личный кабинет <span className={styles.lkText}>{isLogin ? '[ ' + authUser + ' ]' : ""}</span></span>
                        <img src={iconLK}></img>
                        <span
                            onClick={()=>lkMake()}
                        >{!isLogin ? "[Вход]" : "[Выход]"}</span>
                    </div>
                </div>

            </div>

        )
    }



    return(

        <>
            <div className={[styles.mainCont, styles.header, styles.bigView].join(' ')}>


                <div className={styles.title}>X-Billing Система билинга</div>

                <div className={styles.block3}>
                    {buildLK()}
                </div>
            </div>

            <div className={[styles.mainCont, styles.header, styles.smallView].join(' ')}>




                <div className={styles.block3}>
                    {buildLK()}
                </div>
            </div>
        </>

    );
}
export default Header;